import LocalAttachmentsService from "@mirage/services/LocalAttachmentsService";
import { useCallback } from "react";
import { atom, useSetRecoilState } from "recoil";

export const pdfReaderAtom = atom({
    key: "pdfReaderAtom",
    default: { pdfUrl: "" },
});

const usePdfReader = (service: LocalAttachmentsService) => {
    const setReaderState = useSetRecoilState(pdfReaderAtom);
    const onReaderClicked = useCallback(
        async (attachmentId: number) => {
            if (!attachmentId) {
                return;
            }
            const downloadResult = await service.DownloadAttachment(attachmentId);
            if (!downloadResult?.url) {
                return;
            }
            location.hash = "readDocument";
            const pdfUrl = downloadResult.url.replace("/download", "/show");
            setReaderState({ pdfUrl });
        },
        [service, setReaderState]
    );
    return [onReaderClicked];
};

export default usePdfReader;
